import ShareAndroidSolid from './ShareAndroidSolid'

export default ShareAndroidSolid
// eslint-disable-next-line import/export
export * from './ShareAndroidSolid'
